<ng-container [ngSwitch]="btnType">
  <div class="position-relative">
    <div *ngIf="dev" class="badge-dev">{{ 'coming_soon' | translate }}!</div>
    <div *ngIf="beta" class="badge-beta">{{'test_mode' | translate}}</div>
  </div>
  <ng-container *ngSwitchDefault>
    <button
      mat-button
      [ngClass]="{ 'w-100': full }"
      class="btn-default style-{{styleType}} {{customClass}}"
      (click)="click($event)"
      [disabled]="disabled"
    >
      <ng-template *ngTemplateOutlet="buttonContent"></ng-template>
    </button>
  </ng-container>

  <ng-container *ngSwitchCase="'cancel'">
    <button
      mat-button
      [ngClass]="{ 'w-100': full }"
      class="btn-cancel style-{{styleType}} {{customClass}}"
      (click)="click($event)"
      [disabled]="disabled"
    >
      <ng-template *ngTemplateOutlet="buttonContent"></ng-template>
    </button>
  </ng-container>

  <ng-container *ngSwitchCase="'stroked'">
    <button
      mat-stroked-button
      [ngClass]="{ 'w-100': full }"
      class="btn-stroked style-{{styleType}} {{customClass}}"
      (click)="click($event)"
      [disabled]="disabled"
    >
      <ng-template *ngTemplateOutlet="buttonContent"></ng-template>
    </button>
  </ng-container>

  <ng-container *ngSwitchCase="'icon'">
    <button
      mat-icon-button
      [attr.aria-label]="ariaLabel"
      class="btn-icon style-{{styleType}} {{customClass}}"
      (click)="click($event)"
      [disabled]="disabled"
    >
      <ng-template *ngTemplateOutlet="buttonContent"></ng-template>
    </button>
  </ng-container>


  <ng-container *ngSwitchCase="'icon-bg'">
    <button
      mat-icon-button
      class="btn-icon-bg style-{{styleType}} {{customClass}}"
      (click)="click($event)"
      [disabled]="disabled"
    >
      <ng-template *ngTemplateOutlet="buttonContent"></ng-template>
    </button>
  </ng-container>


  <ng-container *ngSwitchCase="'no-btn'">
    <div
      [ngClass]="{ 'w-100': full }"
      class="style-{{styleType}} {{customClass}}"
      (click)="click($event)"
    >
      <ng-template *ngTemplateOutlet="buttonContent"></ng-template>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="'no-border'">
    <button
      mat-stroked-button
      [ngClass]="{ 'w-100': full }"
      class="btn-no-border {{customClass}}"
      (click)="click($event)"
    >
      <ng-template *ngTemplateOutlet="buttonContent"></ng-template>
    </button>
  </ng-container>

  <ng-container *ngSwitchCase="'raised'">
    <button
      mat-raised-button
      [ngClass]="{ 'w-100': full }"
      class="btn-raised style-{{styleType}} {{customClass}}"
      (click)="click($event)"
      [disabled]="disabled"
    >
      <ng-template *ngTemplateOutlet="buttonContent"></ng-template>
    </button>
  </ng-container>
</ng-container>

<!-- Button Content Template -->
<ng-template #buttonContent>
  <ng-content></ng-content>
</ng-template>
